// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"Thumb--2Xebm","single":"single--3nCQD","picture":"picture--1g57n","handle":"handle--31HNO","upload":"upload--2z4a_","multiple":"multiple--3AaWA"};